const accessRoute = {
  AI_MATCHING_SCORE: {
    path: "/admin/ai-matching-score",
  },
};
export default accessRoute;
